<template>
  <div>
    <div v-if="$store.getters.LINKMODE">
      <div class="ln_solid"></div>
      <b-alert variant="info" show>
        <button type="button" @click="disableLink()" class="close">
          <span aria-hidden="true">&times;</span>
        </button>
        Link Mode Enabled!
      </b-alert>
      <div class="ln_solid"></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    disableLink() {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to disable link mode?.", {
          title: "Disable Link Mode?",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.$store.commit("disablelinkMode");
          }
        });
    },
  },
  created: {},
};
</script>

